module.exports = __webpack_public_path__ + "static/img/Drinking_500px.f836d7a.png";